import React from "react";

import Button from "material-ui/Button";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "material-ui/Dialog";

import { withStyles } from "material-ui/styles";

import { isAnswer, isCustomerAdmin } from "utils/formatter";
import storage from "utils/storage";

const styles = {
  contentText: {
    whiteSpace: "pre-line"
  }
};

class ErrorDialog extends React.Component {
  setContent(error) {
    if (this.props.errorDialog.open) {
      console.error(error, error.message);
    }

    switch (error.message) {
      case "systemError":
        return `予期せぬエラーが発生しました。
          ご不便をおかけし恐縮ですが、時間をおいて再度アクセスいただき、
          状況が改善しない場合はサポートまでご連絡いただけますようお願いいたします。`;
      case "authError":
        return `ログイン情報が確認できませんでした。
          ログイン画面からやり直してください。`;
      case "staleObjectError":
        return `更新に失敗しました。
          表示されているデータは最新ではない可能性があります。
          画面を再読み込みし、最新のデータを確認してください。`;
      case "recordNotFound":
        return `データの取得に失敗しました。
          表示されているデータは最新ではない可能性があります。
          画面を再読み込みし、最新のデータを確認してください。`;
      case "previewRecordNotFound":
        return `データの取得に失敗しました。
          表示されているデータは最新ではない可能性があります。
          画面を再読み込みし、最新のデータを確認してください。`;
      case "expiredResetToken":
        return `パスワード再設定の有効期限が切れました。
          お手数ですがパスワード再設定画面から再度操作をお願いします。`;
      case "Network Error":
        return `サーバに接続できませんでした。
          電波状態、回線状態をご確認いただき再度お試しください。`;
      // ブラウザバックによる不正な操作
      case "invalidOperation":
        return `データの取得に失敗しました。
          画面を再読み込みしてください。`;
      default:
        return `予期せぬエラーが発生しました。
          ご不便をおかけし恐縮ですが、時間をおいて再度アクセスいただき、
          状況が改善しない場合はサポートまでご連絡いただけますようお願いいたします。`;
    }
  }

  setActions(error) {
    switch (error.message) {
      case "systemError":
        return this.sytemErrorAction();
      case "authError":
        return this.authErrorAction();
      case "staleObjectError":
        return this.staleObjectErrorAction();
      case "recordNotFound":
        return this.recordNotFoundAction();
      case "previewRecordNotFound":
        return this.previewRecordNotFound();
      case "expiredResetToken":
        return this.expiredResetTokenAction();
      case "Network Error":
        return this.networkErrorAction();
      case "invalidOperation":
        return this.invalidOperationAction();
      default:
        return this.defaultAction();
    }
  }

  sytemErrorAction() {
    return (
      <div>
        <Button onClick={() => window.location.reload()}>再読み込み</Button>
      </div>
    );
  }

  authErrorAction() {
    return (
      <div>
        <Button
          onClick={() => {
            this.props.handleClose();
            if (isAnswer()) {
              this.props.historyPush(`/login/survey/${storage.getUrlToken()}`);
            } else if (isCustomerAdmin()) {
              this.props.historyPush("/");
            } else {
              this.props.historyPush("/login");
            }
            window.location.reload();
          }}
        >
          ログイン画面へ
        </Button>
      </div>
    );
  }

  staleObjectErrorAction() {
    return (
      <div>
        <Button onClick={() => window.location.reload()}>再読み込み</Button>
      </div>
    );
  }

  recordNotFoundAction() {
    return (
      <div>
        <Button onClick={() => this.props.backToHome()}>再読み込み</Button>
      </div>
    );
  }

  previewRecordNotFound() {
    return (
      <div>
        <Button onClick={() => this.props.windowClose()}>閉じる</Button>
      </div>
    );
  }

  networkErrorAction() {
    return (
      <div>
        <Button onClick={() => window.location.reload()}>再読み込み</Button>
      </div>
    );
  }

  expiredResetTokenAction() {
    return (
      <Button
        onClick={() => {
          this.props.handleClose();
          this.props.historyPush("/send_reset_password");
        }}
      >
        移動
      </Button>
    );
  }

  invalidOperationAction() {
    return (
      <div>
        <Button onClick={() => window.location.reload()}>再読み込み</Button>
      </div>
    );
  }

  defaultAction() {
    return <Button onClick={this.props.handleClose}>閉じる</Button>;
  }

  render() {
    const { open, error } = this.props.errorDialog;

    return (
      <Dialog
        disableBackdropClick={process.env.NODE_ENV === "production"}
        open={open}
        onClose={this.props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">エラー</DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            className={this.props.classes.contentText}
          >
            {this.setContent(error)}
          </DialogContentText>
        </DialogContent>
        <DialogActions>{this.setActions(error)}</DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(ErrorDialog);



// WEBPACK FOOTER //
// ./src/components/ErrorDialog.jsx